import React from 'react';

import TemplateGallery from 'Shared/components/TemplateGallery/TemplateGallery';

import './WorkspaceChooseTemplateSection.scss';

type Props = {
  isGroup: boolean;
};

function WorkspaceChooseTemplateSection({ isGroup }: Props) {
  return (
    <div className="WorkspaceChooseTemplateSection pt-5">
      <div className="WorkspaceChooseTemplateSection__title mb-2">Choose a Template to Begin</div>
      <div className="WorkspaceChooseTemplateSection__description mb-4">
        Start setting up your workspace with a template
      </div>

      <TemplateGallery isGroup={isGroup} isInitialChoice />
    </div>
  );
}

export default WorkspaceChooseTemplateSection;
